import React from 'react';

import { useTranslation } from 'client/hooks';

import Icon from '../../Icon';
import PopupWrapper from '../PopupWrapper';
import Button from '../../Button';

import css from './StopBroadcastPopup.module.scss';

interface Props {
  onCancel: () => void;
  onSubmit: () => void;
  isLiveStreamBusy: boolean;
}

const StopBroadcastPopup: React.FC<Props> = ({ onCancel, onSubmit, isLiveStreamBusy }) => {
  const { translate } = useTranslation('popUps');

  return (
    <PopupWrapper onClose={onCancel}>
      <div className={css.container}>
        <div className={css.icon}>
          <Icon type="broadcast-end-sm" />
        </div>
        <div className={css.title}>
          <span>{translate('closeRoomPopUp.title')}</span>
        </div>
        <Button
          className={css.agreeBtn}
          onClickHandler={onSubmit}
          disabled={isLiveStreamBusy}
          label={translate('closeRoomPopUp.agreeBtn')}
        />
        <Button
          className={css.cancelBtn}
          onClickHandler={onCancel}
          label={translate('closeRoomPopUp.cancelBtn')}
          isCustom
        />
      </div>
    </PopupWrapper>
  );
};

export default StopBroadcastPopup;
